import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Popover } from '../../../../global/popover/popover';
import DefaultButton from '../../../../global/default-button/default-button';
import { AssetsFileForm } from './assets-file-form.container';
import { ITitleAssetUrlDTO } from '../../../../../api/assets.dao';

import './assets-file-form.scss';
interface IProps {
    accountId: number;
    eventId: number;
    organizationId?: number | null;
    attendeeId?: number | null;
    file: ITitleAssetUrlDTO;
    onDeleteAsset: (objectKey?: string) => void;
    uploadProfileImage?: (file: File, organizationId: number, attendeeId: number) => void;
    disabled?: boolean;
    fileProtected?: boolean;
}

const AssetsFileFormWrapper = (props: IProps) => {
    const {
        accountId,
        eventId,
        file,
        onDeleteAsset,
        uploadProfileImage = null,
        disabled = false,
        organizationId = null,
        attendeeId = null,
        fileProtected
    } = props;

    const [isViewsOpen, setIsViewsOpen] = useState<boolean>(false);
    const [elementPosition, setElementPosition] = useState<{element: number; window: number}>(null);
    const viewsRef = useRef(null);

    useEffect(() => {
        if (isViewsOpen) {
            setElementPosition({
                element: window.scrollY + viewsRef.current.getBoundingClientRect().bottom,
                window: window.scrollY + document.documentElement.clientHeight
            });
        }
    }, [isViewsOpen]);

    return (
        <div
            className='assets-download-file-button-wrapper'
            ref={viewsRef}
        >
            <DefaultButton
                text={file.title}
                className={classnames('download-item add-attendee-btn visible-on-hover', isViewsOpen && 'active')}
                modifier='row'
                onClick={() => setIsViewsOpen(true)}
                disabled={disabled}
                withEllipsis
            />

            <Popover
                isOpen={isViewsOpen}
                buttonRef={viewsRef}
                withCloseIcon
                onClose={() => setIsViewsOpen(false)}
                onClickOutside={e => {
                    const target = (e.target as Element)?.closest('.assets-download-file-form-in-popover');
                    /* e.composedPath - don`t close popup by scrolling */
                    if (!target && e.composedPath().length > 3) {
                        setIsViewsOpen(false);
                    }
                }}
                customWidth={382}
                padding={0}
                align='start'
                position='bottom'
                customTop={elementPosition && ((elementPosition.element + 300) > elementPosition.window ? -200 : null)}
            >
                <AssetsFileForm
                    accountId={accountId}
                    eventId={eventId}
                    organizationId={organizationId}
                    attendeeId={attendeeId}
                    file={file}
                    closeAssetsFilePopup={() => setIsViewsOpen(false)}
                    onDeleteAsset={onDeleteAsset}
                    uploadProfileImage={uploadProfileImage}
                    fileProtected={fileProtected}
                />
            </Popover>
        </div>
    );
};


export { AssetsFileFormWrapper };
